import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { baseUrl } from '@app/services/api/api.service';
import { StateService } from '@app/services/state/state.service';
import { PasscodeTokenService } from '@app/services/passcode-token.service';

const PASSCODE_TOKEN_HEADER = 'X-Quote-Passcode-Token';

export const passcodeTokenInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.url !== baseUrl) {
    return next(req);
  }

  const stateService = inject(StateService);
  const passcodeTokenService = inject(PasscodeTokenService);

  const portalLink = stateService.getState().portalLink;
  const token = passcodeTokenService.getToken(portalLink);

  if (!token) {
    return next(req);
  }

  return next(req.clone({ setHeaders: { [PASSCODE_TOKEN_HEADER]: token } }));
};
